export default {
  MULTIPLE_CHOICES: 300,
  NOT_FOUND: 404,
};
